<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Profile Info</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'home' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <form class="text-start mx-auto" @submit.prevent="editUser" enctype="multipart/form-data">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">Name</label>
                    <input type="text" class="form-control" placeholder="Enter Name" v-model="name" />
                    <span class="error text-small block" v-if="errors.name">{{ errors.name }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">Email</label>
                    <input type="email" class="form-control" placeholder="Enter Email" v-model="email" />
                    <span class="error text-small block" v-if="errors.email">{{ errors.email }}</span>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="infoServiceName">Phone</label>
                    <input type="text" class="form-control" placeholder="Enter Phone" v-model="phone" required />
                    <span class="error text-small block" v-if="errors.phone">{{ errors.phone }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Age</label>
                    <input type="number" class="form-control" placeholder="Enter Age" v-model="age" />
                    <span class="error text-small block" v-if="errors.age">{{ errors.age }}</span>
                  </div>
                </div>

                <div class="form-group ">
                  <label class="text-">District</label>
                  <multiselect v-model="selectedDistrict" :options="districts" :searchable="true" label="name"
                    track-by="id" placeholder="Select a District" :multiple="false"></multiselect>
                  <span class="error text-small block" v-if="errors.district_id">{{ errors.district_id }}</span>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label class="block">
                      Gender
                    </label>
                    <div class="clip-radio radio-primary">
                      <input type="radio" id="female" v-model="gender" value="female">
                      <label for="female">
                        Female
                      </label>
                      <input type="radio" id="male" v-model="gender" value="male" checked="checked">
                      <label for="male">
                        Male
                      </label>
                    </div>
                    <span class="error text-small block" v-if="errors.gender">{{ errors.gender }}</span>
                  </div>
                </div>

                <!-- <div class="form-group">
                  <label class="text-">Select Role</label>
                  <multiselect v-model="selectedRole" :options="roles" :searchable="true" label="name" track-by="id"
                    placeholder="Select Role" :multiple="false" aria-required="true"></multiselect>
                  <span class="error text-small block" v-if="errors.role_id">{{ errors.role_id }}</span>
                </div> -->
              </div>
              <button class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->

      <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label>Area Of Residence</label>
                    <input type="text" class="form-control" placeholder="Enter Area Of Residence"
                      v-model="area_of_residence" />
                  </div>
                </div> -->

      <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label>Default Language</label>
                    <select class="form-control" v-model="default_language">
                      <option value="">Select Language</option>
                      <option value="en">English</option>
                      <option value="ar">Arabic</option>
                    </select>
                  </div>
                </div> -->

      <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label>Default Country</label>
                    <select class="form-control" v-model="default_country">
                      <option value="">Select Country</option>
                      <option value="EGYPT">EGYPT</option>
                      <option value="KSA">Saudi Arabia</option>
                      <option value="UAE">United Arab Emirates</option>
                    </select>
                  </div>
                </div> -->
      <!-- <div class="form-group col-md-12">
                  <label for="image" class="form-label">Image</label>
                  <input id="image" type="file" class="form-control-file" @change="handleFileChange" accept="image/*" />
                  <div class="fileinput-preview fileinput-exists thumbnail mt-2">
                    <img v-if="imagePreview" :src="imagePreview" class="image-preview" alt="Image"
                      @click="removeImage" />
                  </div>
                </div> -->
      <!-- <div class="form-group">
                  <label class="text-">Medical Insurances</label>
                  <multiselect v-model="selectedMedicalInsurance" :options="medicalInsurances" :searchable="true"
                    label="name_en" track-by="id" placeholder="Select Insurances" :multiple="true"></multiselect>
                </div>
                -->

      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import Multiselect from "vue-multiselect";
import { store } from "@/Store";
export default {
  name: "ShowUser",
  components: {
    Multiselect,
  },
  data() {
    return {
      name: "",
      email: "",
      gender: "",
      phone: "",
      active: false,
      default_language: "en",
      selectedDistrict: "",
      districts: [],
      age: "",
      image: null,
      imagePreview: null,
      medicalInsurances: [],
      selectedMedicalInsurance: [],
      roles: [],
      selectedRole: "",
      errors: {}, // Store validation errors
      // defaultImage: 'assets/images/avatar-1-xl.jpg',
      user_id: store.user ? store.user.id : null,
    };
  },
  created() {
    this.fetchUser();
    this.fetchDistricts();
  },

  methods: {

    async fetchDistricts() {
      try {
        const response = await axios.get("/admin/admin/district/all");
        this.districts = response.data.data;
        this.meta = response.data.meta;
      } catch (error) {
        console.error(error);
      }
    },
    // handleFileChange(event) {
    //   const file = event.target.files[0];
    //   if (file) {
    //     this.image = file;
    //     this.imagePreview = URL.createObjectURL(file);
    //   }
    //   event.target.value = null;
    // },
    // removeImage() {
    //   this.image = null;
    //   this.imagePreview = null;
    // },

    async fetchUser() {
      console.log("Fetching user");
      try {
        const response = await axios.get(
          "/api/admin/user/get?id=" + this.user_id
        );

        const UserData = response.data.data;
        console.log(response.data.data)
        this.name = UserData.name;
        this.email = UserData.email;
        this.phone = UserData.phone;
        this.gender = UserData.gender;
        this.selectedDistrict = UserData.district;
        this.area_of_residence = UserData.area_of_residence;
        this.default_language = UserData.default_language;
        this.default_country = UserData.default_country;
        this.selectedMedicalInsurance = UserData.medical_insurance;
        // this.active = UserData.active === 1;
        this.age = UserData.age;


        // this.selectedRole = UserData.role.id;
        // this.selectedRole = UserData.role ?? null;
        // if (UserData.image) {
        //   this.imagePreview = UserData.image;
        // }
        console.log('userdata', UserData);
      } catch (error) {
        console.error(error);
      }
    },
    validateForm() {
      this.errors = {};

      // Name validation
      if (this.name && this.name.length > 255) {
        this.errors.name = "Name must be less than 255 characters.";
      }

      // Gender validation
      if (this.gender && !['male', 'female'].includes(this.gender)) {
        this.errors.gender = "['Gender must be either 'male' or 'female'.']";
      }

      // Phone validation
      if (!this.phone) {
        this.errors.phone = "Phone is required.";
      } else if (!/^\d{11}$/.test(this.phone)) {
        this.errors.phone = "['Phone must be 11 digits.']";
      }

      // District validation
      if (this.selectedDistrict && !this.districts.some(district => district.id === this.selectedDistrict.id)) {
        this.errors.district_id = "['Invalid district selected.']";
      }

      // Age validation
      if (this.age && (isNaN(this.age) || this.age < 18)) {
        this.errors.age = "['Age must be a number and at least 18.']";
      }

      return Object.keys(this.errors).length === 0;
    },
    async editUser() {
      if (!this.validateForm()) {
        return; // Stop if validation fails
      }
      try {
        const formData = new FormData();
        const user_id = store.user ? store.user.id : null;
        formData.append("id", user_id);
        // formData.append("id", this.$route.params.id);
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("gender", this.gender);
        formData.append("phone", this.phone);
        // formData.append("active", this.active ? 1 : 0);
        // formData.append("active", this.active ? 1 : 0);
        if (this.selectedDistrict) {
          formData.append("district_id", this.selectedDistrict.id);
        }
        formData.append("age", this.age);
        formData.append("default_language", this.default_language);
        // if (this.selectedRole) {
        //   formData.append("role_id", this.selectedRole.id);
        // }

        // if (this.image) {
        //   formData.append("image", this.image); // Append the selected file
        // }
        // this.selectedMedicalInsurance.forEach((medicalInsurance, index) => {
        //   formData.append(`medical_insurance[${index}]`, medicalInsurance.id);
        // });

        // formData.append("role_id", this.selectedRole);

        const response = await axios.post(
          "/api/admin/user/update",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(response.data);
        console.log(formData);
        this.$router.push({ name: "home" });
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log("Validation errors:", this.errors);
        } else {
          console.error("Error creating doctor:", error);
        }
      }
    },
  },
};
</script>
<style scoped>
form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  /* Add a background color */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Add a shadow for better visibility */
  width: 100%;
  /* max-width: 500px; Optional: Max width for better responsiveness */
}

form>.form-group {
  margin-bottom: 1.5rem;
}

button {
  width: 100%;
}

.error {
  color: #a94442;
  font-size: 0.875em;
}

.submit-button {
  width: 100%;
}
</style>